function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 374",
  fill: "none",
  stroke: "#3c00dc",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 416",
  d: "M66.741 53.201a27.62 27.62 0 10-41.586 0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 53",
  d: "M39.61 56.997v2.381"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 54",
  d: "M46.047 56.997v2.381"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 55",
  d: "M52.484 56.997v2.381"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 417",
  d: "M82.193 28.524h-2.335a34.463 34.463 0 01-.648 15.775h2.983a4.885 4.885 0 004.885-4.885v-6.005a4.885 4.885 0 00-4.885-4.885z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 418",
  d: "M11.417 35.031a34.675 34.675 0 01.621-6.507H9.703a4.885 4.885 0 00-4.885 4.885v6.005a4.885 4.885 0 004.885 4.885h2.983a34.539 34.539 0 01-1.269-9.268z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 419",
  d: "M45.916 65.435a56.833 56.833 0 01-24.262-5.454v6.382a5.95 5.95 0 005.95 5.95h36.164a5.95 5.95 0 005.949-5.95v-6.168a56.794 56.794 0 01-23.801 5.24z",
  strokeWidth: 0.937
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 420",
  d: "M69.737 65.99l-.019.019v.135a6.169 6.169 0 01-6.169 6.169H27.823a6.169 6.169 0 01-6.169-6.169h0C14.217 66.144.448 76.955.448 86.955v7.289h91v-7.289c0-10.225-13.188-20.979-21.711-20.965z",
  strokeWidth: 0.896
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 421",
  d: "M45.948.5a34.525 34.525 0 00-23.461 59.859 56.618 56.618 0 0046.976-.05A34.524 34.524 0 0045.948.5z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 373",
  strokeWidth: 0.82
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 422",
  d: "M69.717 60.065v5.926h.019c4.055-.007 9.164 2.426 13.408 6.078V62.18a8.283 8.283 0 00-8.283-8.283h0a34.758 34.758 0 01-5.144 6.168z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 423",
  d: "M27.604 68.161h-.153.373z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 424",
  d: "M21.654 66.144h.021l-.015-6.577a34.736 34.736 0 01-4.62-5.668h-.007a8.282 8.282 0 00-8.282 8.282v10.192c4.273-3.718 9.321-6.229 12.903-6.229z"
})));

function SvgAstronautinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.896,
    height: 94.692,
    viewBox: "0 0 91.896 94.692"
  }, props), _ref);
}

export default SvgAstronautinline;